import {useSupportActions} from "./hooks/useSupportActions";
import {IconContact, IconSupport} from "@bounce/shared/consumer/bounce-ui";
import {IconLogout} from "@bounce/shared/ui";
import {CustomMenuItem} from "@bounce/shared/consumer/components";
import {useAuth} from "@bounce/shared/contexts";
import React from "react";

const SupportOptions = () => {
  const {loggedIn} = useAuth();
  const {onLogout, onSupportClick, onManageContactClick, shouldDisplaySupportOptions} = useSupportActions();

  if (!shouldDisplaySupportOptions) return null;

  return (
    <>
      <CustomMenuItem
        label={"Manage contact details"}
        icon={<IconContact width={20} height={20} />}
        onClick={onManageContactClick}
      />
      <CustomMenuItem onClick={onSupportClick} label="Contact us" icon={<IconSupport width={20} height={20} />} />
      {loggedIn && <CustomMenuItem onClick={onLogout} label="Log out" icon={<IconLogout width={20} height={20} />} />}
    </>
  );
};

export default SupportOptions;
